import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'El mejor ambiente de Bogotá. Las hamburguesas son increíbles y los cócteles tienen una presentación de otro nivel.',
    author: 'María G.',
    source: 'Cliente frecuente'
  }, {
    text: 'Fui por primera vez y quedé enamorada del lugar. La atención fue impecable y el ambiente es exactamente como lo muestran en Instagram.',
    author: 'Carlos M.',
    source: 'Google Reviews'
  }, {
    text: 'Celebré mi cumpleaños en Zona T y fue una experiencia inolvidable. La música, la comida y el servicio, todo perfecto.',
    author: 'Andrea P.',
    source: 'Instagram'
  }];
  return <section className="py-20 md:py-32 bg-brand-secondary" data-id="element-328">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-329">
        <div className="text-center mb-16" data-id="element-330">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-cream mb-4" data-id="element-331">
            Lo que dicen nuestros clientes
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-332"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-333">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="bg-brand-primary p-8 rounded-2xl border-t-4 border-t-brand-gold border-x border-b border-brand-gold/10" data-id="element-334">
              <div className="flex space-x-1 mb-6" data-id="element-335">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-brand-gold text-brand-gold" data-id="element-336" />)}
              </div>
              <p className="text-brand-cream/80 text-lg italic mb-8 leading-relaxed" data-id="element-337">
                "{t.text}"
              </p>
              <div data-id="element-338">
                <p className="text-brand-cream font-semibold" data-id="element-339">{t.author}</p>
                <p className="text-brand-gold text-sm" data-id="element-340">{t.source}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}